import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { ImmomioButtonComponent } from '@immomio/ui/button';
import {
  getLegalTexts,
  getLegalTextsActionState,
  ILegalTexts,
  UserLegalInfoPageBaseComponent,
} from '@resident-nx/shared';
import { footerNavItems, hasLegalText } from '@resident-nx/web';
import { KeycloakService } from '@resident-nx/web/data-access';
import { CardWebComponent, LoaderWebComponent } from '@resident-nx/web/ui';

@Component({
  selector: 'rs-web-legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.scss'],
  imports: [
    LoaderWebComponent,
    CardWebComponent,
    RouterLink,
    TranslatePipe,
    ImmomioButtonComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalWebComponent extends UserLegalInfoPageBaseComponent {
  #keycloakService = inject(KeycloakService);
  #store = inject(Store);
  #legalTexts = this.#store.selectSignal(getLegalTexts);

  // bound from the `link` query param via withComponentInputBinding
  public link = input<keyof ILegalTexts>();

  public legalTextsState = this.#store.selectSignal(getLegalTextsActionState);
  public legalText = computed(() => {
    const text = this.#legalTexts()?.[this.link()];
    return typeof text === 'string' && hasLegalText(text) ? text : null;
  });
  public isLoggedIn = computed(() => !!this.#keycloakService.tokenSignal());
  public legalTextName = computed(
    () => footerNavItems.find(item => item.link === this.link())?.name
  );
}
